import { render, staticRenderFns } from "./VapeTracker.vue?vue&type=template&id=4af556f4&"
import script from "./VapeTracker.vue?vue&type=script&lang=js&"
export * from "./VapeTracker.vue?vue&type=script&lang=js&"
import style0 from "./VapeTracker.vue?vue&type=style&index=0&id=4af556f4&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nicholashaskell/Local/kicknic/app/public/wp-content/themes/kicknic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4af556f4')) {
      api.createRecord('4af556f4', component.options)
    } else {
      api.reload('4af556f4', component.options)
    }
    module.hot.accept("./VapeTracker.vue?vue&type=template&id=4af556f4&", function () {
      api.rerender('4af556f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/scripts/components/VapeTracker.vue"
export default component.exports